import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CasesRoutingModule } from './cases-routing.module';
import { CasesComponent } from './cases.component';
import { SharedModule } from '../shared.module';
import { AgGridModule } from 'ag-grid-angular';

@NgModule({
  imports: [
    CasesRoutingModule,
    SharedModule,
    AgGridModule
  ],
  declarations: [CasesComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CasesModule { }
